import React, { FC, ReactNode, useEffect, useState } from "react";
import { Outlet } from "react-router";
import {
  getUserDetail,
  loginGuest,
  refresh_token,
  registerGuest,
  RegisterGuestArguments,
  verify_token,
} from "../requests/user";
import { generateRandomKey } from "../utils/utils";
import { useStorage } from "../hooks/location-store";
import { useLoginSuccess } from "../hooks/login";
import {
  cleanAuthorizationToken,
  getAuthorizationToken,
  getIsExpire,
} from "../utils/http-client";
import { toastSuccess, toastError } from "../utils/notification";
import { PuffLoader } from "react-spinners";
import { append_activate_user } from "../requests/statistic";

const IndexLayout = () => {
  return (
    <div className="w-screen h-screen bg-background dark:bg-dark-background">
      <div className="mx-auto max-w-screen-xl h-full max-h-full  shadow-md relative">
        <div className="w-full h-full absolute top-0 left-0">
          <IndexLayoutAuthentication>
            <Outlet />
          </IndexLayoutAuthentication>
        </div>
      </div>
    </div>
  );
};

const IndexLayoutAuthentication: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [registerModel, setRegisterModel] =
    useState<Nullable<RegisterGuestArguments>>(null);
  const [logined, setLogined] = useState<boolean>(false);
  const loginSuccess = useLoginSuccess();
  const { getItem, addItem, removeItem } = useStorage();
  const KEY = "_$REGISTER_GUEST_MODEL";

  useEffect(() => {
    // 在组件加载时检查用户的登录状态
    const hasLogin = !!getAuthorizationToken();
    // token是否过期
    const is_expired = getIsExpire();
    console.log("是否登录", hasLogin);
    if (hasLogin && !is_expired) {
      //token没有过期续费token
      fetchVerifyToken();
    } else {
      //token过期，重新登录，或重新注册用户
      handleAutoLogin();
    }
  }, []);

  const handleAutoLogin = async () => {
    const register_model = await handleReadDiskLoginModel();
    if (!register_model) {
      return handleAutoRegister();
    }
    fetchLoginGuest(register_model);
  };

  //校验token是否有效
  const fetchVerifyToken = async () => {
    const res = await verify_token();
    if (res?.success) {
      fetchRefreshToken();
    } else {
      handleAutoLogin();
    }
  };

  const fetchRefreshToken = async () => {
    const res = await refresh_token();
    if (res?.success) {
      setLogined(true);
      loginSuccess(res.data);
      //用户当天活跃标记
      append_activate_user();
    } else {
      //token过期，重新登录
      handleAutoLogin();
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      fetchRefreshToken();
    }, 1000 * 60 * 60); //每小时刷新一次token
    return () => clearInterval(timer);
  }, []);

  const handleReadDiskLoginModel = (): Promise<
    Nullable<RegisterGuestArguments>
  > => {
    const diskModelStr = getItem(KEY);
    if (!diskModelStr) return Promise.resolve(null);
    return new Promise((r) => {
      try {
        const model = JSON.parse(diskModelStr);
        r(model);
      } catch (error) {
        console.log("读取磁盘数据失败", error);
        removeItem(KEY); // 删除无效的磁盘数据
        r(null);
      }
    });
  };

  const handleAutoRegister = () => {
    getRandomRegisterModel();
  };

  // 自动生成游客注册信息
  const getRandomRegisterModel = () => {
    const randomUserName = generateRandomKey();
    const password = "123";
    const email = generateRandomKey() + "@gmail.com";
    const randomModel = {
      username: randomUserName,
      password: password,
      email: email,
    };
    setRegisterModel(randomModel);
  };

  // 自动注册游客
  useEffect(() => {
    if (registerModel) {
      fetchRegister();
    }
  }, [registerModel]);

  const fetchRegister = async () => {
    if (!registerModel) return;
    try {
      const res = await registerGuest(registerModel);
      console.log("自动注册响应", res);
      if (res?.success) {
        console.log("注册游客成功", res);
        handleSaveToDisk();
        handleAutoLogin();
      } else {
        console.log("注册游客失败", res);
        toastError("注册失败，正在重新注册...");
        removeItem(KEY);
        setTimeout(() => {
          handleAutoRegister(); // 3秒后重新注册
        }, 3000);
      }
    } catch (error) {
      console.error("注册请求失败", error);
      toastError("注册请求失败，请重试");
    }
  };

  // 将游客信息保存到本地存储
  const handleSaveToDisk = () => {
    addItem(KEY, JSON.stringify(registerModel));
  };

  // 登录游客
  const fetchLoginGuest = async (model: RegisterGuestArguments) => {
    if (!model) return;
    const res = await loginGuest(model.username, model.password);
    if (res) {
      console.log("登录成功");
      loginSuccess(res);
      setLogined(true);
    } else {
      //登录失败需要重新注册用户
      console.log("登录失败");
      handleAutoRegister();
    }
  };

  // 如果未登录，直接执行注册/登录流程
  if (!logined) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        {/* 这里可以显示加载指示器，等待自动注册或登录 */}
        {/* <PuffLoader size={60} color="#36D7B7" /> */}
      </div>
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default IndexLayout;
